import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SitesService } from '@portal-core/sites/services/sites.service';
import { Team } from '@portal-core/teams/models/team.model';
import { TeamsService } from '@portal-core/teams/services/teams.service';
import { TeamPageFilterConfig } from '@portal-core/teams/util/team-page-filter-config';
import { ListControl } from '@portal-core/ui/list/util/list-control';
import { ListBase } from '@portal-core/ui/list/util/list.base';
import { of } from 'rxjs';

@Component({
  selector: 'mc-site-teams-list',
  templateUrl: './site-teams-list.component.html',
  styleUrls: ['./site-teams-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteTeamsListComponent extends ListBase<Team> implements OnChanges {
  @Input() siteId: number;
  @Input() canEdit: boolean = false;

  @Output() saved: EventEmitter<void> = new EventEmitter<void>();

  removing: number[] = [];

  filterConfig: TeamPageFilterConfig = new TeamPageFilterConfig(['Name']);

  listControl: ListControl<Team> = new ListControl<Team>(this.teamsService, filter => {
    if (typeof this.siteId === 'number') {
      return this.sitesService.getTeamsPageBySiteId$(this.siteId, filter);
    } else {
      return of(null);
    }
  });

  constructor(
    private sitesService: SitesService,
    private teamsService: TeamsService,
    private snackBar: MatSnackBar,
  ) {
    super(teamsService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.siteId) {
      this.hardReload();
    }
  }

  onRemoveTeam(teamId: number) {
    this.removing = [
      ...this.removing,
      teamId
    ];
    this.teamsService.removeSiteFromTeam$(this.siteId, teamId).subscribe(() => {
      this.teamsService.removePagedDataListItems$(this.dataListId, [teamId]);
      this.removing = this.removing.filter(id => id !== teamId);
      this.saved.emit();
    }, error => {
      this.removing = this.removing.filter(id => id !== teamId);
      this.snackBar.open('Unable to remove team.', 'OK');
    });
  }
}
